import { api } from '@/config/api';
export interface PlanLimits {
  maxUsers: number;
  maxContacts: number;
  maxCampaignsPerMonth: number;
  maxMessagesPerMonth: number;
  aiCreditsPerMonth: number;
  maxWhatsappAccounts: number;
  maxFacebookAccounts: number;
  maxGoogleAdsAccounts: number;
  maxTiktokAccounts: number;
  maxBotFlows: number;
}
export interface Plan { _id: string; planId: string; name: string; displayName: string; monthlyPriceUsd: number; limits: PlanLimits; includedModules?: string[]; isActive: boolean; sortOrder: number; }
export const plansService = {
  list: async (): Promise<Plan[]> => (await api.get('/super_admin/plans')).data,
  create: async (p: Omit<Plan, '_id'>): Promise<Plan> => (await api.post('/super_admin/plans', p)).data,
  update: async (id: string, p: Omit<Plan, '_id'>): Promise<Plan> => (await api.patch(`/super_admin/plans/${id}`, p)).data,
  remove: async (id: string) => { await api.delete(`/super_admin/plans/${id}`); },
};
